module.exports = __webpack_public_path__ + "img/over-38-billion-desktop.f8a0bc01.svg";